import { isOptedOut } from './optout'
import { resolveSite } from './site'

const GA_MEASUREMENT_ID = 'G-JZYGC5C9W8'

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

function dcucPrivacySignal(){return location.pathname==='/dcuc' && (navigator.doNotTrack==='1' || (navigator as Navigator & {globalPrivacyControl?:boolean}).globalPrivacyControl===true)}

let loaded = false

export function initAnalytics() {
  if (!import.meta.env.PROD) return
  if (typeof window === 'undefined') return
  if (isOptedOut() || dcucPrivacySignal()) return
  loadGtag()
}

function loadGtag() {
  if (loaded) return
  loaded = true

  const script = document.createElement('script')
  script.id = 'ga-script'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false })
  // Tag every hit with the resolved tenant (umbrella | nasaa | dcuc | amba) so
  // GA4 can segment by subdomain regardless of the `?site=` preview override.
  // Register `site` as a custom dimension (event + user scope) in GA4 Admin to
  // surface it in reports. `page_location` already carries the real hostname.
  const site = resolveSite()
  window.gtag('set', 'user_properties', { site })
  window.gtag('event', 'page_view', {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
    site,
  })
}

export function trackPageview(path: string, title?: string) {
  if (!import.meta.env.PROD) return
  if (isOptedOut() || dcucPrivacySignal()) return
  if (typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title ?? document.title,
    site: resolveSite(),
  })
}
